import { Divider, Header, Icon, Segment, Tab, Table } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../app/stores/store';

export default observer(function TechMetaData() {
  const {
    userStore: { user },
    commonStore,
    viewStore: { technicalMetadata },
  } = useStore();

  return (
    <Tab.Pane
      className={
        commonStore.filterModeZero?.includes('AVLAVF03')
          ? 'component-isDisabled metadata-parent-tab'
          : 'metadata-parent-tab'
      }
    >
      <Segment.Group
        className={
          user?.displayName !== 'Rujula' ? 'MetaDataUser' : 'MetaDataAdmin'
        }
      >
        <Divider horizontal>
          <Header color="teal" as="h4">
            <Icon name="film" />
            Technical
          </Header>
        </Divider>
        <Table definition>
          {technicalMetadata?.map((a) => {
            return (
              <Table.Body>
                <Table.Row>
                  <Table.Cell width={7}>
                    <strong>{a?.elementName}</strong>
                  </Table.Cell>
                  <Table.Cell width={7}>
                    <span>{a?.elementValue}</span>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            );
          })}
          {/* {metadata?.length === 0 ? (
            <Header style={{ marginLeft: '260px', padding: '20px' }}>
              No Technical Details found
            </Header>
          ) : null} */}
        </Table>
      </Segment.Group>
    </Tab.Pane>
  );
});
